const colors = {
  mainColor: '#4C9C2E',
  grey: '#76777B',
  lightgrey: '#F4F4F4',
  white: 'white',
};

export default colors;
